/**
 * A place for all VeeValidate customizations
 */
import dayjs from 'dayjs';
import { required, email, min, max, regex, between, double } from 'vee-validate/dist/rules';
import { extend, setInteractionMode } from 'vee-validate';

export default {
    install(Vue, options) {
        setInteractionMode('passive');
        extend('min', {
            ...min,
            message: (field) => {
                return `The ${field} is not valid.`;
            },
        });
        extend('max', {
            ...max,
            message: (field) => {
                return `The ${field} is not valid.`;
            },
        });
        extend('email', {
            ...email,
            message: (field) => {
                return `Invalid email address.`;
            },
        });
        extend('regex', regex);
        extend('between', {
            ...between,
            message: (field, args) => {
                return `The ${field} field must be between ${args.min} and ${args.max}`;
            },
        });
        extend('double', {
            ...double,
            message: (field, args) => {
                return `The ${field} must be numeric and may contain ${args.decimals} decimal points`;
            },
        });
        extend('required', {
            ...required,
            message: (field) => {
                return `Required field`;
            },
        });

        extend('areaOfInterest', {
            ...required,
            message: (field) => {
                return `The area of interest field is required`;
            },
        });

        extend('password', (value) => {
            const conditions = {
                specialChars: /[!@#$%^&*]/,
                lowercase: /[a-z]/,
                uppercase: /[A-Z]/,
                numbers: /[0-9]/,
            };
            const tests = [];

            Object.values(conditions).forEach((condition) => {
                tests.push(value.match(condition));
            });

            const hasPassedConditions = tests.filter((test) => test === null).length <= 1;

            return value.length >= 8 && hasPassedConditions;
        });

        extend('date_format', {
            validate: (value) => {
                const date = dayjs(value, 'MM/DD/YYYY', true);
                return date.isValid();
            },
            message: 'Please enter a valid birthday',
        });

        extend('date_between', {
            validate: (value) => {
                const date = dayjs(value).format('MM/DD/YYYY');
                const startDate = dayjs(new Date('1899/12/31')).format('MM/DD/YYYY');
                const today = dayjs(new Date()).format('MM/DD/YYYY');

                if (dayjs(date).isAfter(startDate) && dayjs(date).isBefore(today)) {
                    return true;
                }
                return false;
            },
            message: 'Please enter a valid birthday',
        });

        extend('tel', (value) => {
            return Boolean(value.match(/^[0-9\s\-\+\\\(\)\.]+$/));
        });
    },
};
